import { cn } from '@/utils/cn';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'overlay';
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', variant = 'overlay', className }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  // Inline SVG spinner to avoid external icon dependency (keeps bundle smaller and consistent)
  const spinnerElement = (
    <svg
      className={cn('text-primary animate-spin', sizeClasses[size], className)}
      viewBox="0 0 24 24"
      aria-label="Loading"
      role="status"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
      <title>Loading</title>
    </svg>
  );

  if (variant === 'overlay') {
    return (
      <div className="pointer-events-none fixed left-24 z-[9999] flex h-full min-h-screen w-full items-center justify-center">
        {spinnerElement}
      </div>
    );
  }

  return spinnerElement;
};
